// extracted by mini-css-extract-plugin
export default {"root":"SplashPage_root__DoNzC","imageContainer":"SplashPage_imageContainer__cOy58"};